import glo from '../../main'
import { tkParse } from '@moke/vue-tk'
import searchRoom from './component/wyOrder/searchRoom.vue'
import searchState from './component/wyOrder/searchState.vue'
export default {
  className: 'order',
  title: '取暖费订单',
  render: (record) => {
    return record.orderId
  },
  fields: [
    {
      name: 'room',
      width: 180,
      validators: [
        (val) => val ? null : '房间号不可为空'
      ],
      search: {
        component: searchRoom
      }
    },
    {
      name: 'user',
      searchKey: ['nickName'],
      note: '缴费人',
      render: (record) => {
        return (record.state === 'completed' && record.user && record.user.nickName) || '-'
      },
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      }
    },
    {
      name: 'state',
      search: {
        component: searchState
      }
    },
    {
      name: 'money',
      width: 120,
      note: '应缴金额'
    },
    {
      name: 'relMoney',
      width: 120,
      render: (record) => {
        return (record.state === 'completed' && record.relMoney) || '-'
      }
    },
    {
      name: 'remark'
    },
    {
      name: 'timeDone',
      note: '完成时间'
    }
  ],
  search: [
    'room',
    'user',
    'state',
    'payName'
  ],
  action: {
    imports: {
      type: 'list',
      icon: 'import',
      text: '取暖费导入',
      callback: async function imports ({ vm }) {
        try {
          const excel = await glo.$excel.pick()
          const exceldata = excel.toJson()
          glo.$loading.show()
          for (let i = 0; i < exceldata.Sheet1.length; i++) {
            const element = exceldata.Sheet1[i]
            // 获取对象的key
            const keys = Object.keys(element)
            // 判断两个数组元素是否相同
            const board = ['小区名称', '楼号', '单元', '房号', '费用']
            const isSame = keys.every((item) => board.includes(item))
            if (!isSame) {
              throw new Error()
            }
            if (!(element['小区名称'] && element['楼号'] && element['单元'] && element['房号'] && element['费用'])) { // 是否有必填的
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据异常`
              })
              if (i > 0) {
                vm.refresh()
              }
              return
            }
            const reside = element['小区名称'].toString()
            const floor = element['楼号'].toString()
            const unit = element['单元'].toString()
            const room = element['房号'].toString()
            const money = element['费用'].toString()

            // const money = Number(element['费用'].result)
            const res = await Promise.all([
              tkParse.get(`/classes/residentialQuarters`, {
                params: {
                  where: {
                    name: reside
                  }
                }
              }),
              tkParse.get(`/classes/floor`, {
                params: {
                  where: {
                    name: floor
                  }
                }
              }),
              tkParse.get(`/classes/unit`, {
                params: {
                  where: {
                    name: unit
                  }
                }
              }),
              tkParse.get(`/classes/roomNumber`, {
                params: {
                  where: {
                    name: room
                  }
                }
              })
            ])
            let resideId, floorId, unitId, roomId
            if (res[0].data.results.length > 0) {
              resideId = res[0].data.results[0].objectId
            }
            if (res[1].data.results.length > 0) {
              floorId = res[1].data.results[0].objectId
            }
            if (res[2].data.results.length > 0) {
              unitId = res[2].data.results[0].objectId
            }
            if (res[3].data.results.length > 0) {
              roomId = res[3].data.results[0].objectId
            }
            console.log(resideId, floorId, unitId, roomId)
            if (resideId && floorId && unitId && roomId) {
              const res = await tkParse.get(`/classes/house`, {
                params: {
                  where: {
                    community: resideId,
                    building: floorId,
                    unit: unitId,
                    room: roomId
                  }
                }
              })
              console.log('i', i)
              console.log(res.data.results)
              if (res.data.results.length > 0) {
                console.log('money', money, parseFloat(money))
                await tkParse.post(`/classes/order`, {
                  type: 'heating',
                  state: 'bePaid',
                  room: res.data.results[0].objectId,
                  money: parseFloat(money)
                })
              } else {
                glo.$loading.hide()
                glo.$notification['error']({
                  message: '操作失败',
                  description: `第${i + 1}条数据异常`
                })
                if (i > 0) {
                  vm.refresh()
                }
                return
              }
            } else {
              glo.$loading.hide()
              glo.$notification['error']({
                message: '操作失败',
                description: `第${i + 1}条数据异常`
              })
              if (i > 0) {
                vm.refresh()
              }
              return
            }
          }
          glo.$loading.hide()
          glo.$notification['success']({
            message: '操作成功',
            description: '数据已导入'
          })
          vm.refresh()
        } catch (e) {
          glo.$loading.hide()
          glo.$notification['error']({
            message: '操作失败',
            description: '请检查数据'
          })
        }
      }
    },
    download: {
      type: 'list',
      text: '下载模板',
      callback: async function () {
        window.open('https://moke-runji.oss-cn-beijing.aliyuncs.com/f2b2cdaf-ded3-4c5d-add0-cb514732b8e3.xlsx', '_blank')
      }
    },
    edit: {
      type: 'row',
      text: '编辑',
      component: 'akModelEditor',
      fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
        room: false, // 隐藏一个字段
        user: false,
        state: false,
        coupun: false,
        money: false,
        relMoney: false,
        timeDone: false
      }
    },
    delete: {
      type: 'row',
      text: '删除',
      callback: async function ({ record, vm }) {
        await vm.confirm('警告', '确认删除这条记录吗?')
        try {
          await tkParse.put(`/classes/order/${record.objectId}`, {
            isDelete: true
          })
          vm.$notification['success']({
            message: '操作成功',
            description: '数据已删除'
          })
          vm.refresh()
        } catch (e) {
          console.log('删除物业订单异常', e)
          vm.$notification['error']({
            message: '操作失败',
            description: '网络错误，请重试'
          })
        }
      },
      hidden: ({ record }) => {
        return record && record.state !== 'bePaid'
      }
    },
    create: false
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'heating'
      where.isDelete = {
        $ne: true
      }
    }
  }
}
